import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const DeviceAdsManagerService = {
  // Bulk assign ads to devices
  bulkAssignAds: async (adsData) => {
    try {
      const response = await apiService.post("/devicesads/bulk", adsData);
      return response.data;
    } catch (error) {
      console.error("Error assigning ads to devices:", error);
      throw error;
    }
  },

  // Get ads by MAC ID
  getAdsByMacId: async (macId) => {
    try {
      const response = await apiService.get(`/devicesads/by-mac/${macId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching device ads:", error);
      throw error;
    }
  },
};

export default DeviceAdsManagerService;
